export default __webpack_public_path__ + "static/media/Voldemort's Wand - Img - Final (2)_07.49e7430e.jpg";